import { atom } from 'jotai';
import { Branch } from 'interfaces/branch';

export const branchesAtom = atom<Branch[]>([]);

export const selectedBranchAtom = atom<Branch | null>(null);
